// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldWithIcon_wrapper__+YFX4","icon":"FieldWithIcon_icon__+zlVi","text":"FieldWithIcon_text__5rMsF"};